import { render } from "./StreamsPage.vue?vue&type=template&id=f9106a8c&scoped=true"
import script from "./StreamsPage.vue?vue&type=script&lang=js"
export * from "./StreamsPage.vue?vue&type=script&lang=js"

import "./StreamsPage.vue?vue&type=style&index=0&id=f9106a8c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9106a8c"]])

export default __exports__